import { Component, ElementRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { fromToolbar } from 'shared/classroom/toolbar/data-access';
import { ToolbarButtonPencilComponent } from '../components/toolbar-button/toolbar-button-pencil/toolbar-button-pencil.component';
import { ToolbarButtonArrowComponent } from '../components/toolbar-button/toolbar-button-arrow/toolbar-button-arrow.component';
import { ToolbarButtonEllipseComponent } from '../components/toolbar-button/toolbar-button-ellipse/toolbar-button-ellipse.component';
import { StrokeWidthComponent } from '../components/stroke-width/stroke-width.component';
import { AsyncPipe, NgClass } from '@angular/common';
import { ColorPaletteComponent } from '../components/color-palette/color-palette.component';

@Component({
    selector: 'pcp-drawing-menu',
    templateUrl: './drawing-menu.component.html',
    styleUrl: './drawing-menu.component.scss',
    imports: [
        ToolbarButtonPencilComponent,
        ToolbarButtonArrowComponent,
        ToolbarButtonEllipseComponent,
        StrokeWidthComponent,
        NgClass,
        ColorPaletteComponent,
        AsyncPipe,
    ]
})
export class DrawingMenuComponent {
    
    readonly isDrawingMenuOpened$ = this.store.select(
        fromToolbar.isDrawingMenuOpened
    );

    constructor(
        private store: Store,
        private hostElement: ElementRef<HTMLElement>
    ) {
        this.store.select(fromToolbar.selectDrawingMenuPosition)
            .pipe(
                takeUntilDestroyed()
            ).subscribe(
                position => { 
                    const classes = this.hostElement.nativeElement.classList;
                    //addding only one class for positioning the drawing menu:
                    if (position != null && !classes.contains(position)) {
                        classes.remove('left', 'right');
                        classes.add(position);
                    }
                }
            )
    }
}
